// extracted by mini-css-extract-plugin
export default {"counter":"InverseCounterInMilliseconds_counter__GVI9t","alertCounter":"InverseCounterInMilliseconds_alertCounter__jCbCg"};